__webpack_require__.p = "/assets/static/widget/";